import { MouseEvent } from 'react';

export const SocialButton = ({
  logo,
  text,
  disabled,
  onClick
}: {
  logo: JSX.Element;
  text: string;
  disabled?: boolean;
  onClick: (ev: MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <button type='button' className='btn btn-social w-100 my-2' disabled={disabled} onClick={onClick}>
      {logo}
      <span className='ms-3'>{text}</span>
    </button>
  );
};
